var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLockers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "95px",
    width: "95px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-23.15 -23.15 509.30 509.30",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 463 463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m343.5,0h-224c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5h8.5v408.5c0,10.336 6.71,19.128 16,22.266v9.734c0,4.142 3.357,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-8.5h145v8.5c0,4.142 3.357,7.5 7.5,7.5s7.5-3.358 7.5-7.5v-9.734c9.29-3.138 16-11.93 16-22.266v-408.5h8.5c4.143,0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zm-200.5,47h81v385h-72.5c-4.687,0-8.5-3.813-8.5-8.5v-376.5zm168.5,385h-72.5v-385h81v376.5c0,4.687-3.814,8.5-8.5,8.5zm8.5-400h-177v-17h177v17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.5,263c12.958,0 23.5-10.542 23.5-23.5s-10.542-23.5-23.5-23.5-23.5,10.542-23.5,23.5 10.542,23.5 23.5,23.5zm0-32c4.687,0 8.5,3.813 8.5,8.5s-3.813,8.5-8.5,8.5-8.5-3.813-8.5-8.5 3.813-8.5 8.5-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.5,216c-12.958,0-23.5,10.542-23.5,23.5s10.542,23.5 23.5,23.5 23.5-10.542 23.5-23.5-10.542-23.5-23.5-23.5zm0,32c-4.687,0-8.5-3.813-8.5-8.5s3.813-8.5 8.5-8.5 8.5,3.813 8.5,8.5-3.814,8.5-8.5,8.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockers);
export default __webpack_public_path__ + "static/media/icon-lockers.2175c2a18a944c8ac05a1b121f39b614.svg";
export { ForwardRef as ReactComponent };